import { useHomeRegion } from '@/hooks/useHomeRegion'
import { LocationChip } from './LocationChip'
import { RegionPicker } from './RegionPicker'

/**
 * The viewer's region in the app header, on the pages it scopes (Home's
 * friends' plans, Discover's list, the Crew activity feed). It's one app-wide setting, so it lives in
 * the chrome rather than among a page's own filters.
 */
export function RegionHeaderChip() {
  const { regionId, setRegion } = useHomeRegion()
  return (
    <RegionPicker regionId={regionId} onSelect={(id: string) => setRegion(id, 'location_chip')}>
      {/* Shares the mobile header with the centred logo, so it gets the space beside it. */}
      <LocationChip
        compact
        regionId={regionId}
        className="-ml-1.5 max-w-[calc(50vw-5.5rem)] gap-1 px-1.5 text-sm text-foreground/85 md:ml-0 md:max-w-none [&_svg]:size-4"
      />
    </RegionPicker>
  )
}
